import React from 'react';

export const ParagraphedText = React.memo(function ParagraphedText({ text }) {
  if (!text) return null;
  return text.split('\n').map((item, index) => <p key={index}>{item}</p>);
});
